import * as React from 'react'
import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'
//* =========================== Styled Components ==============================

const Container = styled(animated.div)<{ theme: string; compact: boolean }>`
  color: ${(props) => (props.theme === 'dark' ? 'white' : 'black')};
  background: ${(props) => (props.theme === 'dark' ? 'black' : 'white')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: bold;

  font-size: 14px;
  padding: ${(props) => (props.compact ? '8px 0' : '10px 0')};
  width: ${(props) => (props.compact ? '120px' : '150px')};
  border-radius: ${(props) => (props.compact ? '6px' : '10px')};

  @media (min-width: 43em) {
    font-size: 18px;
    padding: ${(props) => (props.compact ? '8px 0' : '15px 0')};
    width: ${(props) => (props.compact ? '150px' : '250px')};
    border-radius: ${(props) => (props.compact ? '10px' : '15px')};
  }
`

export const SubmitVideoButton = ({
  theme = 'dark',
  compact = false,
}: {
  theme?: string
  compact?: boolean
}): JSX.Element => {
  const [submitHover, setSubmitHover] = React.useState(false)
  const submitHoverState = useSpring({
    boxShadow: submitHover ? '0px 5px 25px rgba(255,255,255,0.1)' : '0px 0px 0px rgba(0,0,0,0)',
    transform: submitHover ? `translate3d(0,-5%,0)` : `translate3d(0,0%,0)`,
    config: {
      mass: 1,
      tension: 170,
      friction: 26,
      velocity: 0,
    },
  })

  return (
    <Container
      onMouseEnter={() => setSubmitHover(true)}
      onMouseLeave={() => setSubmitHover(false)}
      style={submitHoverState}
      onClick={() => window.open('https://59etnq5pufb.typeform.com/GlassCreator', '_blank')}
      theme={theme}
      compact={compact}
    >
      Apply
    </Container>
  )
}
